import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import Layout from './Layout'
import CustomHome from '../custom/components/Home'

class Home extends Component {
  componentDidMount() {
    this.props.pageView()
  }
  render() {
    return (
      <Layout>
        <Helmet>
          <title>Homepage</title>
        </Helmet>
        this is static homepage
      </Layout>
    )
  }
}

export default CustomHome || Home



// WEBPACK FOOTER //
// ./src/components/Home.js